import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ToolbarEventManagerHelper } from './../../../services/event-managers/toolbar-event-manager.helper';

@Component({
  selector: 'app-do-toggle-expand',
  templateUrl: './do-toggle-expand.component.html',
  styleUrl: './do-toggle-expand.component.scss',
  standalone: false,
})
export class DoToggleExpandComponent extends BaseComponent implements OnInit {
  public isExpanded: boolean = true;
  public hasExpandableNodes: boolean = false;

  constructor(private toolbarEventManagerHelper: ToolbarEventManagerHelper) {
    super();
  }

  ngOnInit(): void {
    this.subscribers.hasExpandableNodes = this.toolbarEventManagerHelper.$DoToolbarHasExpandableNodes.subscribe((hasNodes: boolean) => {
      this.hasExpandableNodes = hasNodes;
    });

    this.subscribers.isAllExpanded = this.toolbarEventManagerHelper.$DoToolbarIsAllExpanded.subscribe((isExpanded: boolean) => {
      this.isExpanded = isExpanded;
    });
  }

  public onToggleExpand(): void {
    if (!this.hasExpandableNodes) {
      return;
    }
    this.toolbarEventManagerHelper.DoToolbarToggleExpand = true;
  }
}
